import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function NcertShortNoteBioTopics() {
  return (
    <>

      <AllSubjectTopics subject="biology" type="ncertshortnote" />

    </>
  );
}

export default NcertShortNoteBioTopics;